import { i18n } from "@lingui/core";
import { toCatalog, type UiCatalog } from "./locale-utils";

export { i18n } from "@lingui/core";

const loaded = new Set<UiCatalog>();

/**
 * Activate the Lingui catalog for an arbitrary language code, loading the
 * compiled messages on first use. `code` is a display/transcript language
 * (e.g. `de-DE`, `fr`); it is mapped to the nearest UI catalog via
 * `toCatalog`, so unsupported languages resolve to English.
 */
export async function loadCatalog(code: string): Promise<UiCatalog> {
  const catalog = toCatalog(code);
  if (!loaded.has(catalog)) {
    const { messages } = await import(`../locales/${catalog}/messages.ts`);
    i18n.load(catalog, messages);
    loaded.add(catalog);
  }
  i18n.activate(catalog);
  return catalog;
}
